import Card from 'react-bootstrap/Card';


import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';


export const NotFound = () => {
    let location = useLocation();
    var state = location.state;

    useEffect(()=> {
        var data = {
            "path": window.location.pathname,
            "href": window.location.href,
            "port": window.location.port,
            "protocol": window.location.protocol,
            "state": location.state,
            "referrer": document.referrer
        }
        console.table(data);
       
    },[]);
    return (
        <h1>Not Found</h1>
    );
}